module.exports = __webpack_public_path__ + "static/media/Joshua Ledwell.5e3122c2.png";